import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations, getTranslation } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = useCallback((key) => {
    return getTranslation(language, key);
  }, [language]);

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    // Store preference
    localStorage.setItem('hotel_language', lang);
  }, []);

  // Load saved preference on mount
  React.useEffect(() => {
    const saved = localStorage.getItem('hotel_language');
    if (saved && translations[saved]) {
      setLanguage(saved);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
